/* Copyright (c) 2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Plugin } from '../common/plugin';
import { PluginManager } from '../common/plugin-manager.service';

/**
 * Injection token for providing a Vega plugin implementation.
 * App module **should always** provide this with `multi: true`.
 */
export const VEGA_PLUGINS = new InjectionToken<Plugin>('VegaPlugins');

/**
 * Injects all VegaPlugin instances provided via VEGA_PLUGINS in the app module.
 */
@Injectable({
    providedIn: 'root'
})
export class VegaPluginManager extends PluginManager {
    constructor(@Optional() @Inject(VEGA_PLUGINS) plugins: Array<Plugin>) {
        super(plugins || []);
    }
}
